// Config Keys
export const PITC_KEY = 'tenant.pitc.enabled';
export const PITC_LOCATION_KEY = 'tenant.pitc.location';
export const DOUBLE_DECKER_KEY = 'tenant.pitc.isDoubleDecker';

// Custom values
export const ABOVE_THE_CONVERSATION = 'ABOVE_THE_CONVERSATION';
export const SIDERAIL = 'SIDERAIL';
export const CUSTOM_LOCATION = 'CUSTOM_LOCATION';
export const FORM = 'form';
export const COUNTER = 'counter';
export const CONVERSATION = 'Conversation';

// Dropdown options
export const PITC_LOCATIONS = [
  { value: ABOVE_THE_CONVERSATION, text: 'Above the conversation' },
  { value: SIDERAIL, text: 'Siderail' },
  { value: CUSTOM_LOCATION, text: 'Custom location' }
];
